import React from 'react';
import styled from 'styled-components';

import { Text, FlexView, Separator, COLORS } from '@cuemath/comps';

const GUTTER = 16;

const Wrapper = styled(FlexView)(
  () => `
  border: 1px solid ${COLORS.GHOST};
  border-radius: ${GUTTER * 0.75}px
  margin-bottom: ${GUTTER * 3}px;
`,
);

const Tag = styled(FlexView)`
  border-top-left-radius: ${GUTTER * 0.75}px;
  border-top-right-radius: ${GUTTER * 0.75}px;
  background: ${COLORS.SUN_XXLIGHT};
`;

const StyledImage = styled.img`
  flex: 1;
  height: ${GUTTER * 13.375}px;
  max-width: ${GUTTER * 10}px;
  border-radius: 8px;
  border-width: 0.3px;
  overflow: hidden;
  justifycontent: 'center';
  margin: 3px;
`;

function RealWorldProject(props) {
  const { realWorldProjectInfo, realWorldProjectReport } = props;
  const { images = [], observation } = realWorldProjectReport || {};

  const { activity, objective, image_upload_urls: fileUploadURLs } =
    realWorldProjectInfo || {};

  return (
    <Wrapper>
      <Tag
        gutter={GUTTER * 0.75}
        gap={GUTTER / 2}
        alignItems="center"
        background="YELLOW_1"
      >
        <Text renderAs="eyebrow2">{activity}</Text>
      </Tag>
      <FlexView gutter={GUTTER * 0.75} gap={GUTTER * 0.75}>
        <FlexView flexDirection="row" alignItems="center" justifyContent="center">
          {images.map((item, idx) => (
            <StyledImage src={fileUploadURLs[item]} resizeMode="stretch"></StyledImage>
          ))}
        </FlexView>
        <Separator height={GUTTER * 0.75} transparent />
        <Text renderAs="body1Medium">
          Objective:&nbsp;
          <Text renderAs="body2">{objective}</Text>
        </Text>
        <Separator height={GUTTER * 0.75} transparent />
        {!!observation && (
          <Text renderAs="body1Medium">
            Teacher remarks:&nbsp;
            <Text renderAs="body2">{observation}</Text>
          </Text>
        )}
      </FlexView>
    </Wrapper>
  );
}

export default RealWorldProject;
